// extracted by mini-css-extract-plugin
export default {"content-root":"MPtpK","contentRoot":"MPtpK","title":"_1yG2z","message":"_2EOyj","image":"_1rLQ9"};